import TabBar from './tabbar';

export default TabBar;
